import { ComboboxOption } from '@headlessui/react';
import { Fragment } from 'react/jsx-runtime';
import { tv } from 'tailwind-variants';
import { useTranslation } from '@dagens/frontend-i18n';
import { CommandPaletteResult } from '@components/command-palette/result';
import Loader from '_common/components/loader/Loader';
import { ProducerProduct } from 'types/Product';
import { ReqType } from 'utils/REQ';

const style = tv({
  slots: {
    title: `
      mb-xxs
      px-xs
      text-microText
    `,
    list: `
      flex
      flex-col
      justify-start
    `
  }
});

type Props = {
  req: ReqType;
  results: ProducerProduct[];
};

export const CommandPaletteResultsProducts = ({ req, results }: Props) => {
  const { t } = useTranslation();
  const { title, list } = style();
  if (results.length === 0 && req !== 'PENDING') {
    return null;
  }

  return (
    <li key="pages">
      <h2 className={title()}>{t('common:Products')}</h2>
      {req === 'PENDING' ? (
        <Loader />
      ) : (
        <ul className={list()}>
          {results.map(item => {
            const to = `/my-products/${item._id}`;
            return (
              <ComboboxOption as={Fragment} key={item._id} value={to}>
                {({ focus }) => (
                  <CommandPaletteResult
                    icon="products"
                    text={item.name}
                    to={to}
                    focused={focus}
                  />
                )}
              </ComboboxOption>
            );
          })}
        </ul>
      )}
    </li>
  );
};
